module.exports = __webpack_public_path__ + "img/partner3.dd98d3e0.jpg";